import { Injectable, inject } from '@angular/core';
import { Params, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class CanaryService {
  private router = inject(Router);

  get enabled(): boolean {
    return !!localStorage.getItem('canary');
  }

  /**
   * `?canary` on ANY url turns canary mode on. This lives on the service rather than on
   * CanaryComponent because the badge now renders inside the toolbar, which AppMode.HELP does not
   * render — the switch has to keep working on every route, so AppComponent drives it.
   *
   * The already-enabled guard matters: enable() navigates and reloads, so re-enabling on every
   * emission of the same url would reload the page underneath the user.
   */
  enableFromQueryParams(params: Params): void {
    if (params['canary'] !== undefined && !this.enabled) this.enable();
  }

  disable() {
    localStorage.removeItem('canary');
    this.router.navigate([]).then(() => setTimeout(() => location.reload(), 500));
  }

  enable() {
    localStorage.setItem('canary', 'true');
    this.router.navigate([]).then(() => setTimeout(() => location.reload(), 500));
  }
}
